import { render } from "./FundCard.vue?vue&type=template&id=5a0eef9a&scoped=true&ts=true"
import script from "./FundCard.vue?vue&type=script&lang=ts"
export * from "./FundCard.vue?vue&type=script&lang=ts"

import "./FundCard.vue?vue&type=style&index=0&id=5a0eef9a&scoped=true&lang=scss"

import exportComponent from "/builds/gh_prod_devops/gh_prod_devops_web/funds_prod_deploy/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a0eef9a"]])

export default __exports__